import { Info, Close } from 'react-bytesize-icons';
import * as React from 'react';
export default {
  Info,
  Close,
  React
};